import React from 'react';
import { VenueProfileContext } from '../../context';
import { Venues } from '@weddingspot/ws-api-client';
import UpcomingEvent from './UpcomingEvent';

import styles from './UpcomingEvents.module.scss';

const UpcomingEvents = () => {
    const context = React.useContext(VenueProfileContext);

    const wsVenueProfile = React.useMemo(() => context.wsVenueProfile, []) as Venues.VenueDetails;
    if (!wsVenueProfile.upcoming_events || !wsVenueProfile.upcoming_events.length) {
        return null;
    }
    return (
        <div className={styles.upcoming}>
            <h2>Upcoming Events</h2>
            <div className={styles.list}>
                {wsVenueProfile.upcoming_events.slice(0, 4).map((event) => (
                    <UpcomingEvent key={event.id} event={event} />
                ))}
            </div>
        </div>
    );
};

export default UpcomingEvents;
